<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { useObjectTree } from './../model/model'
import { computed } from 'vue'
import { TreeDeleteButton } from '@/features/Tree/TreeDelete'
import type { ObjectTreeItemType } from '@/entities/ObjectsTree'
import { TreePasteButton } from '@/features/Tree/TreeMove'
import { ObjectTypeIds } from '@/entities/Object'
import { useAuth } from '@/entities/Auth'

const tree = useObjectTree()
const { isPermissions } = useAuth()

/* Вычисляем позицию контекстного меню */
const position = computed(() => {
  return {
    top: `${tree.contextPosition.y}px`,
    left: `${tree.contextPosition.x}px`,
  }
})

/**
 * Обрабатываем клик вне объекта
 */
const outsideHandler = () => {
  tree.contextObject = null
}

/**
 * Обработчик вырезания объекта
 */
const cutHandler = () => {
  if (tree.selectObjects.length) {
    tree.cutObjects = [...tree.selectObjects]
  } else {
    tree.cutObjects = [tree.contextObject as ObjectTreeItemType]
  }

  tree.contextObject = null
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="tree.contextObject"
      :style="position"
      class="v-tree-context"
      v-click-outside="outsideHandler"
    >
      <div class="v-tree-context__item" v-if="isPermissions(['OBJECT_MOVE'])" @click="cutHandler">
        <VIcons type="content_cut" /> {{ $t('itf.cut') }}
      </div>

      <TreePasteButton
        class="v-tree-context__item"
        :class="{ 'v-tree-context__item_inactive': !tree.cutObjects.length }"
        v-if="tree.contextObject.type === ObjectTypeIds.GROUPS && isPermissions(['OBJECT_MOVE'])"
      />

      <TreeDeleteButton class="v-tree-context__item" v-if="isPermissions(['OBJECT_REMOVE'])" />
    </div>
  </Teleport>
</template>
